import { render, staticRenderFns } from "./valor_mercado.vue?vue&type=template&id=1756af32"
import script from "./valor_mercado.vue?vue&type=script&lang=js"
export * from "./valor_mercado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports